import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
// import { IonicPageModule } from "ionic-angular"
import { CommonModule } from "@angular/common";
import { DefaultMenuComponent } from "./default-menu/default-menu";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatListModule } from "@angular/material/list";
// import { AppRoutingModule } from "../app-routing.module";
import { RouterModule } from "@angular/router";



@NgModule({
	declarations: [DefaultMenuComponent],
	imports: [
        CommonModule,
        MatToolbarModule,
        MatIconModule,
		MatMenuModule,
		MatListModule,
		// AppRoutingModule,
		RouterModule
	],
	exports: [
		DefaultMenuComponent,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class MenuModule { }
